// AUTO-GENERATED from content/recipes/ — do not edit by hand
import { CraftingRecipe, ProfessionType } from '../../CharacterTypes';

export const RECIPE_DATABASE: Map<string, CraftingRecipe> = new Map([
  ['craft_red_potion', {
    id: 'craft_red_potion',
    name: 'Red Potion',
    profession: ProfessionType.ALCHEMY,
    requiredLevel: 1,
    ingredients: [{ itemId: 'mushroom_spore', quantity: 3 }],
    outputItemId: 'red_potion',
    outputQuantity: 2,
  }],
  ['craft_orange_potion', {
    id: 'craft_orange_potion',
    name: 'Orange Potion',
    profession: ProfessionType.ALCHEMY,
    requiredLevel: 5,
    ingredients: [{ itemId: 'slime_gel', quantity: 5 }, { itemId: 'mushroom_spore', quantity: 3 }],
    outputItemId: 'orange_potion',
    outputQuantity: 1,
  }],
  ['craft_blue_potion', {
    id: 'craft_blue_potion',
    name: 'Blue Potion',
    profession: ProfessionType.ALCHEMY,
    requiredLevel: 5,
    ingredients: [{ itemId: 'slime_gel', quantity: 3 }],
    outputItemId: 'blue_potion',
    outputQuantity: 1,
  }],
  ['craft_power_elixir', {
    id: 'craft_power_elixir',
    name: 'Power Elixir',
    profession: ProfessionType.ALCHEMY,
    requiredLevel: 15,
    ingredients: [{ itemId: 'slime_gel', quantity: 10 }, { itemId: 'mushroom_spore', quantity: 10 }, { itemId: 'pig_foot', quantity: 5 }],
    outputItemId: 'power_elixir',
    outputQuantity: 1,
  }],
  ['craft_scroll_return', {
    id: 'craft_scroll_return',
    name: 'Scroll of Return',
    profession: ProfessionType.ALCHEMY,
    requiredLevel: 3,
    ingredients: [{ itemId: 'mushroom_spore', quantity: 5 }, { itemId: 'pig_foot', quantity: 2 }],
    outputItemId: 'return_scroll',
    outputQuantity: 1,
  }],
  ['craft_throwing_star', {
    id: 'craft_throwing_star',
    name: 'Throwing Star',
    profession: ProfessionType.ALCHEMY,
    requiredLevel: 5,
    ingredients: [{ itemId: 'slime_gel', quantity: 3 }],
    outputItemId: 'subi_throwing_star',
    outputQuantity: 50,
    timeToCraftMs: 3000,
  }],
  ['craft_red_potion_bulk', {
    id: 'craft_red_potion_bulk',
    name: 'Red Potion (Bulk)',
    profession: ProfessionType.ALCHEMY,
    requiredLevel: 10,
    ingredients: [{ itemId: 'mushroom_spore', quantity: 10 }, { itemId: 'slime_gel', quantity: 5 }],
    outputItemId: 'red_potion',
    outputQuantity: 10,
    timeToCraftMs: 5000,
  }],
  ['craft_blue_potion_bulk', {
    id: 'craft_blue_potion_bulk',
    name: 'Blue Potion (Bulk)',
    profession: ProfessionType.ALCHEMY,
    requiredLevel: 10,
    ingredients: [{ itemId: 'slime_gel', quantity: 8 }, { itemId: 'mushroom_spore', quantity: 3 }],
    outputItemId: 'blue_potion',
    outputQuantity: 5,
    timeToCraftMs: 5000,
  }],
  ['craft_drake_scale_potion', {
    id: 'craft_drake_scale_potion',
    name: 'Drake Scale Potion',
    profession: ProfessionType.ALCHEMY,
    requiredLevel: 8,
    ingredients: [{ itemId: 'drake_scale', quantity: 2 }, { itemId: 'slime_gel', quantity: 5 }],
    outputItemId: 'orange_potion',
    outputQuantity: 5,
    timeToCraftMs: 5000,
  }],
  ['craft_void_elixir', {
    id: 'craft_void_elixir',
    name: 'Void Elixir',
    profession: ProfessionType.ALCHEMY,
    requiredLevel: 10,
    ingredients: [{ itemId: 'dark_essence', quantity: 5 }, { itemId: 'drake_scale', quantity: 3 }, { itemId: 'mushroom_spore', quantity: 10 }],
    outputItemId: 'power_elixir',
    outputQuantity: 2,
    timeToCraftMs: 8000,
  }],
  ['craft_frost_elixir', {
    id: 'craft_frost_elixir',
    name: 'Frost Elixir',
    profession: ProfessionType.ALCHEMY,
    requiredLevel: 8,
    ingredients: [{ itemId: 'drake_scale', quantity: 3 }, { itemId: 'slime_gel', quantity: 10 }],
    outputItemId: 'blue_potion',
    outputQuantity: 10,
    timeToCraftMs: 6000,
  }],
  ['craft_infernal_potion', {
    id: 'craft_infernal_potion',
    name: 'Infernal Potion',
    profession: ProfessionType.ALCHEMY,
    requiredLevel: 12,
    ingredients: [{ itemId: 'cursed_plate', quantity: 3 }, { itemId: 'dark_essence', quantity: 8 }, { itemId: 'drake_scale', quantity: 5 }],
    outputItemId: 'power_elixir',
    outputQuantity: 3,
    timeToCraftMs: 10000,
  }],
  ['craft_endgame_bundle', {
    id: 'craft_endgame_bundle',
    name: 'Adventurer\'s Supply Kit',
    profession: ProfessionType.ALCHEMY,
    requiredLevel: 10,
    ingredients: [{ itemId: 'mushroom_spore', quantity: 20 }, { itemId: 'slime_gel', quantity: 15 }, { itemId: 'pig_foot', quantity: 10 }],
    outputItemId: 'orange_potion',
    outputQuantity: 20,
    timeToCraftMs: 8000,
  }],
  ['craft_bandage', {
    id: 'craft_bandage',
    name: 'Linen Bandage',
    profession: ProfessionType.ALCHEMY,
    requiredLevel: 1,
    ingredients: [{ itemId: 'slime_gel', quantity: 3 }],
    outputItemId: 'bandage',
    outputQuantity: 5,
  }],
  ['craft_antidote', {
    id: 'craft_antidote',
    name: 'Antidote',
    profession: ProfessionType.ALCHEMY,
    requiredLevel: 3,
    ingredients: [{ itemId: 'mushroom_spore', quantity: 5 }, { itemId: 'slime_gel', quantity: 2 }],
    outputItemId: 'antidote',
    outputQuantity: 3,
  }],
  ['craft_speed_elixir', {
    id: 'craft_speed_elixir',
    name: 'Elixir of Speed',
    profession: ProfessionType.ALCHEMY,
    requiredLevel: 5,
    ingredients: [{ itemId: 'mushroom_spore', quantity: 8 }, { itemId: 'pig_foot', quantity: 3 }],
    outputItemId: 'elixir_of_speed',
    outputQuantity: 2,
    timeToCraftMs: 4000,
  }],
  ['craft_fortitude_elixir', {
    id: 'craft_fortitude_elixir',
    name: 'Elixir of Fortitude',
    profession: ProfessionType.ALCHEMY,
    requiredLevel: 8,
    ingredients: [{ itemId: 'stone_fragment', quantity: 3 }, { itemId: 'drake_scale', quantity: 2 }],
    outputItemId: 'elixir_of_fortitude',
    outputQuantity: 2,
    timeToCraftMs: 5000,
  }],
  ['craft_flask_of_titans', {
    id: 'craft_flask_of_titans',
    name: 'Flask of the Titans',
    profession: ProfessionType.ALCHEMY,
    requiredLevel: 12,
    ingredients: [{ itemId: 'dark_essence', quantity: 5 }, { itemId: 'cursed_plate', quantity: 2 }, { itemId: 'drake_scale', quantity: 3 }, { itemId: 'stone_fragment', quantity: 5 }],
    outputItemId: 'flask_of_the_titans',
    outputQuantity: 1,
    timeToCraftMs: 10000,
  }],
  ['craft_silver_ring', {
    id: 'craft_silver_ring',
    name: 'Silver Ring',
    profession: ProfessionType.ALCHEMY,
    requiredLevel: 5,
    ingredients: [{ itemId: 'stone_fragment', quantity: 5 }, { itemId: 'slime_gel', quantity: 10 }],
    outputItemId: 'silver_ring',
    outputQuantity: 1,
    timeToCraftMs: 8000,
  }],
  ['craft_boots_of_swiftness', {
    id: 'craft_boots_of_swiftness',
    name: 'Swiftwind Trail',
    profession: ProfessionType.ALCHEMY,
    requiredLevel: 8,
    ingredients: [{ itemId: 'drake_scale', quantity: 5 }, { itemId: 'slime_gel', quantity: 10 }, { itemId: 'pig_foot', quantity: 8 }],
    outputItemId: 'boots_of_swiftness',
    outputQuantity: 1,
    timeToCraftMs: 10000,
  }],
  ['craft_ring_of_power', {
    id: 'craft_ring_of_power',
    name: 'Ring of Power',
    profession: ProfessionType.ALCHEMY,
    requiredLevel: 12,
    ingredients: [{ itemId: 'dark_essence', quantity: 10 }, { itemId: 'cursed_plate', quantity: 5 }, { itemId: 'drake_scale', quantity: 8 }, { itemId: 'stone_fragment', quantity: 10 }],
    outputItemId: 'ring_of_power',
    outputQuantity: 1,
    timeToCraftMs: 15000,
  }],
  ['craft_fire_scroll', {
    id: 'craft_fire_scroll',
    name: 'Fire Attack Scroll',
    profession: ProfessionType.ALCHEMY,
    requiredLevel: 10,
    ingredients: [{ itemId: 'fire_crystal', quantity: 2 }, { itemId: 'enchanted_dust', quantity: 5 }],
    outputItemId: 'attack_scroll',
    outputQuantity: 3,
    timeToCraftMs: 6000,
  }],
  ['craft_frost_scroll', {
    id: 'craft_frost_scroll',
    name: 'Frost Defense Scroll',
    profession: ProfessionType.ALCHEMY,
    requiredLevel: 10,
    ingredients: [{ itemId: 'frost_shard', quantity: 2 }, { itemId: 'enchanted_dust', quantity: 5 }],
    outputItemId: 'defense_scroll',
    outputQuantity: 3,
    timeToCraftMs: 6000,
  }],
  ['craft_experience_scroll', {
    id: 'craft_experience_scroll',
    name: 'Experience Scroll',
    profession: ProfessionType.ALCHEMY,
    requiredLevel: 12,
    ingredients: [{ itemId: 'void_fragment', quantity: 1 }, { itemId: 'enchanted_dust', quantity: 10 }, { itemId: 'dark_essence', quantity: 5 }],
    outputItemId: 'experience_scroll',
    outputQuantity: 1,
    timeToCraftMs: 12000,
  }],
  ['craft_guild_stone', {
    id: 'craft_guild_stone',
    name: 'Guild Summon Stone',
    profession: ProfessionType.ALCHEMY,
    requiredLevel: 12,
    ingredients: [{ itemId: 'void_fragment', quantity: 2 }, { itemId: 'fire_crystal', quantity: 3 }, { itemId: 'frost_shard', quantity: 3 }],
    outputItemId: 'guild_summon_stone',
    outputQuantity: 1,
    timeToCraftMs: 15000,
  }],
  ['craft_mana_candy_bulk', {
    id: 'craft_mana_candy_bulk',
    name: 'Mana Candy (Bulk)',
    profession: ProfessionType.ALCHEMY,
    requiredLevel: 3,
    ingredients: [{ itemId: 'mushroom_spore', quantity: 5 }, { itemId: 'slime_gel', quantity: 3 }],
    outputItemId: 'mana_candy',
    outputQuantity: 20,
  }],
]);

export function getRecipeList(): CraftingRecipe[] {
  return Array.from(RECIPE_DATABASE.values());
}
